import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import Card from "@/ui/Card";
import LoginForm from "./form";

export default function Login() {
  useDocumentTitle('Sign in')
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect if already authenticated
  if (!loading && user) {
    const from = location.state?.from?.pathname || "/orders";
    navigate(from, { replace: true });
    return null;
  }

  return (
    <div className="min-h-dvh flex items-center justify-center bg-[var(--surface-page)] px-4 py-8 sm:py-12">
      <div className="w-full max-w-[min(24rem,100%)] sm:max-w-sm">
        {/* Logo */}
        <div className="flex justify-center mb-6 sm:mb-8">
          <img
            src="/assets/logo.png"
            alt="Logo"
            className="w-1/4 sm:w-1/3 h-auto"
          />
        </div>

        <Card className="shadow-none border-0 sm:shadow-lg sm:shadow-black/5 sm:border sm:border-[var(--border-default)]">
          <Card.Content className="px-4 py-6 sm:px-6 sm:py-8">
            {/* Header */}
            <div className="text-center space-y-1.5 sm:space-y-2 mb-6 sm:mb-8">
              <h1 className="text-xl sm:text-2xl font-semibold text-[var(--text-primary)]">
                Log in to your account
              </h1>
              <p className="text-sm text-[var(--text-secondary)]">
                Welcome back! Please enter your details.
              </p>
            </div>

            {/* Form */}
            <LoginForm />
          </Card.Content>
        </Card>
      </div>
    </div>
  );
}
